'use client';

import { useIsMobile, useIsNative } from '~/context/common/DeviceContext';
import { useSemTitle } from '~/context/flp/GlobalContext';
import { useModalContext } from '~/context/flp/ModalContext/ModalContext';
import SoftPullMfeModal from './SoftPullMfeModal';

const LANDING_SUBHEADING_HTML =
  'Get your real terms with <strong>no hit to your credit</strong>! Unlock your personalized down and monthly payments in 2 minutes';

export default function SoftpullModal() {
  const isNative = useIsNative();
  const isMobile = useIsMobile();
  const semTitle = useSemTitle();
  const landingHeading = semTitle;
  const landingSubheading = semTitle ? LANDING_SUBHEADING_HTML : undefined;
  const showLogo = Boolean(semTitle) && isMobile;
  const {
    isAddCoApplicantModalOpen,
    isEditCoApplicantModalOpen,
    isSoftPullModalOpen,
    setAddCoApplicantModalOpen,
    setEditCoApplicantModalOpen,
    setSoftPullModalOpen
  } = useModalContext();

  return !isNative ? (
    <SoftPullMfeModal
      consumer="FLP"
      landingHeading={landingHeading}
      landingSubheading={landingSubheading}
      showLogo={showLogo}
      isAddCoApplicantModalOpen={isAddCoApplicantModalOpen}
      isEditCoApplicantModalOpen={isEditCoApplicantModalOpen}
      isSoftPullModalOpen={isSoftPullModalOpen}
      setIsAddCoApplicantModalOpen={setAddCoApplicantModalOpen}
      setIsEditCoApplicantModalOpen={setEditCoApplicantModalOpen}
      setIsSoftPullModalOpen={setSoftPullModalOpen}
      // pass in empty function to ensure we aren't refreshing terms multiple times on modal success/close events
      setShouldRefreshSoftPull={() => {}}
    />
  ) : null;
}
